import React from 'react';
import { Button } from './ui/Button';
import { SunIcon, MoonIcon } from 'lucide-react';
import { useTheme } from './ThemeProvider';
import { LanguageSwitcher } from './LanguageSwitcher';
import { useLanguage } from './LanguageProvider';
import { useTranslation } from 'react-i18next';
import { Logo } from './Logo';
export function Header() {
  const {
    theme,
    toggleTheme
  } = useTheme();
  const {
    t
  } = useTranslation();
  return <header className="bg-adaptive text-adaptive border-adaptive" data-id="element-659">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-4 py-4" data-id="element-660">
        <Logo variant="wordmark" data-id="element-661" />
        <div className="hidden md:flex items-center space-x-8" data-id="element-662">
          <nav className="flex items-center space-x-6" data-id="element-663">
            <a href="#solutions" className="text-sm text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-brand-green" data-id="element-664">
              {t('solutions')}
            </a>
            <a href="#features" className="text-sm text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-brand-green" data-id="element-665">
              {t('features')}
            </a>
            <a href="#how-it-works" className="text-sm text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-brand-green" data-id="element-666">
              {t('howItWorks')}
            </a>
            <a href="#for-business" className="text-sm text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-brand-green" data-id="element-667">
              {t('forBusiness')}
            </a>
          </nav>
          <div className="flex items-center space-x-4" data-id="element-668">
            <div className="flex items-center space-x-2" data-id="element-669">
              <LanguageSwitcher data-id="element-670" />
              <button onClick={toggleTheme} className="flex items-center justify-center w-8 h-8 rounded-full border border-gray-200 dark:border-gray-800 overflow-hidden bg-gray-50 dark:bg-gray-900 text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-brand-green" aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'} data-id="element-671">
                {theme === 'dark' ? <SunIcon className="h-4 w-4" data-id="element-672" /> : <MoonIcon className="h-4 w-4" data-id="element-673" />}
              </button>
            </div>
            <Button className="bg-blue-600 dark:bg-brand-green hover:bg-blue-700 dark:hover:bg-brand-green/90 text-white dark:text-black rounded-full px-6" data-id="element-674">
              {t('getStarted')}
            </Button>
          </div>
        </div>
        <button className="md:hidden text-gray-900 dark:text-white p-2" aria-label="Open menu" data-id="element-675">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-676">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" data-id="element-677" />
          </svg>
        </button>
      </div>
    </header>;
}